export default {
  methods: {
    userHasPermission(permissions) {
      const userPermissions = this.$store.getters.authUserRoles
      let hasPermission = false
      
      permissions.forEach(element => {
        if(userPermissions.indexOf(element) > -1) {
          hasPermission = true
        }
      })
      return hasPermission
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/mixins/permission.js
// module id = null
// module chunks = 